import CardModifierComponent from "Component/Level/CardModifier";
import BaseModifierBehavior from "State/Card/ModifierBehavior/BaseModifierBehavior";
import BombModifierBehavior from "State/Card/ModifierBehavior/BombModifierBehavior";
import CardRewardModifierBehavior from "State/Card/ModifierBehavior/CardRewardModifierBehavior";
import ConnectedModifierBehavior from "State/Card/ModifierBehavior/ConnectedModifierBehavior";
import FogModifierBehavior from "State/Card/ModifierBehavior/FogModifierBehavior";
import IceModifierBehavior from "State/Card/ModifierBehavior/IceModifierBehavior";
import LoweringModifierBehavior from "State/Card/ModifierBehavior/LoweringModifierBehavior";
import PickaxeModifierBehavior from "State/Card/ModifierBehavior/PickaxeModifierBehavior";
import RisingModifierBehavior from "State/Card/ModifierBehavior/RisingModifierBehavior";
import RopeModifierBehavior from "State/Card/ModifierBehavior/RopeModifierBehavior";
import BaseCardModifierHandler from "System/Card/Handler/Modifiers/BaseCardModifierHandler";
import ConnectedModifierHandler from "System/Card/Handler/Modifiers/ConnectedModifierHandler";
import FogModifierHandler from "System/Card/Handler/Modifiers/FogModifierHandler";
import RopeModifierHandler from "System/Card/Handler/Modifiers/RopeModifierHandler";
import TomatoModifierHandler from "System/Card/Handler/Modifiers/TomatoModifierHandler";
import { CardModifierType } from "./CardModifierType";
import BombModifier from "./Modifier/Bomb";
import CardModifier from "./Modifier/CardModifier";
import ConnectedModifier from "./Modifier/Connected";
import FogModifier from "./Modifier/Fog";
import IceModifier from "./Modifier/Ice";
import LoweringModifier from "./Modifier/Lowering";
import PickaxeModifier from "./Modifier/Pickaxe";
import RisingModifier from "./Modifier/Rising";
import RopeModifier from "./Modifier/Rope";

export function getCardModifierHandler(modifier: CardModifier) {
    const modifierComponent = modifier.getComponent(CardModifierComponent);
    return new ModifierTypeMap[modifierComponent.type].handler(modifier);
}

type tModifierType = {
    [cardModifierType in CardModifierType]: {
        prototype: typeof CardModifier;
        behavior: typeof BaseModifierBehavior;
        handler: typeof BaseCardModifierHandler
    };
};

export const ModifierTypeMap: tModifierType = {
    [CardModifierType.bomb]: {
        prototype: BombModifier,
        behavior: BombModifierBehavior,
        handler: TomatoModifierHandler
    },
    [CardModifierType.rising]: {
        prototype: RisingModifier,
        behavior: RisingModifierBehavior,
        handler: BaseCardModifierHandler
    },
    [CardModifierType.lowering]: {
        prototype: LoweringModifier,
        behavior: LoweringModifierBehavior,
        handler: BaseCardModifierHandler
    },
    [CardModifierType.ice]: {
        prototype: IceModifier,
        behavior: IceModifierBehavior,
        handler: BaseCardModifierHandler
    },
    [CardModifierType.pickaxe]: {
        prototype: PickaxeModifier,
        behavior: PickaxeModifierBehavior,
        handler: BaseCardModifierHandler
    },
    [CardModifierType.rope]: {
        prototype: RopeModifier,
        behavior: RopeModifierBehavior,
        handler: RopeModifierHandler
    },
    [CardModifierType.fog]: {
        prototype: FogModifier,
        behavior: FogModifierBehavior,
        handler: FogModifierHandler
    },
    [CardModifierType.card_reward]: {
        prototype: CardModifier,
        behavior: CardRewardModifierBehavior,
        handler: BaseCardModifierHandler
    },
    [CardModifierType.connected]: {
        prototype: ConnectedModifier,
        behavior: ConnectedModifierBehavior,
        handler: ConnectedModifierHandler
    },
};
